import { Checkbox, FormControl, FormControlLabel, InputLabel } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { TipoInscricao } from "../../../../components/Combobox/TipoInscricao";
import { HelperText } from "../../../../components/Errors/HelperText";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import { TipoGeracaoSearchField } from "../../../../components/Searchfields/TipoGeracao";
import styles from "../Cadastro.module.css";
import InputMask from "react-input-mask";
import { formatarCnpj, formatarCpf } from "../../../../infra/utils/FormataValores";
import servSolicitacaoAcesso from "../../../../services/login/servSolicitacaoAcesso";
import { OpcoesUF } from "../../../../components/Combobox/UF";
import { formatarTelefone } from "../../../../infra/utils/FormataValores";
import { useEffect, useState } from "react";
import { maskUC } from "../../../../infra/utils/maskUC";

const Interessado = ({ setIsLoading, setOpenError, setErrorMessage, situacaoSolic, desabilitarCamposSeHouverProtocoloGerado, erroAoRecuperarConsumidor, setErroAoRecuperarConsumidor, onKeyDown, unidadeConsumidora, setUnidadeConsumidora, podeSalvar, uc }) => {
    const { control, getValues, setValue, formState: { errors } } = useFormContext();
    const [mascaraTelefone1, setMascaraTelefone1] = useState("(99) 99999-9999");
    const [mascaraTelefone2, setMascaraTelefone2] = useState("(99) 99999-9999");

    const editavel = situacaoSolic === 0 ? false : true;


    useEffect(() => {
        maskBuilderTelefone1(getValues("FoneCelular1"));
        maskBuilderTelefone2(getValues("FoneCelular2"));

    }, [getValues("FoneCelular1"), getValues("FoneCelular2")]);


    const recuperarDadosConsumidor = async () => {
        try {

            if (!getValues("CodigoUC") || !getValues("Inscricao")) {
                return;
            }

            const situacoesBloqueadas = [1, 4, 5];

            if (situacoesBloqueadas.includes(situacaoSolic)) return;

            let inscricao;

            if (getValues("TipoInscricao")?.value == 1) {
                inscricao = formatarCpf(getValues("Inscricao"));
                inscricao = inscricao.replaceAll("_", "");
            } else {
                inscricao = formatarCnpj(getValues("Inscricao"));
            }

            if (inscricao < 11) {
                return
            }

            var dto = {
                CodigoUC: getValues("CodigoUC"),
                Inscricao: inscricao
            };

            setErroAoRecuperarConsumidor(false);

            const data = await servSolicitacaoAcesso.RecuperarDadosDoConsumidor(dto);

            mapearCamposConsumidor(data.Content);

        } catch (err) {
            setErroAoRecuperarConsumidor(true);
        }
    }

    const mapearCamposConsumidor = (data) => {
        if (data.Nome === getValues("Nome")) {
            return;
        }

        setValue("CEP", data.CEP);
        setValue("Cidade", data.Cidade);
        setValue("Email", data.Email);
        setValue("FoneCelular1", data.Fone1);
        setValue("FoneCelular2", data.Fone2);
        setValue("Nome", data.Nome);
        setValue("NumeroEnd", data.NumeroEnd);
        setValue("Rua", data.Rua);
        setValue("Endereco", data.Bairro);
        setValue("Complemento", data.Complemento);
        setValue("UF", {
            value: data.UF,
            label: OpcoesUF.find((opcao) => opcao.value == data.UF).label
        });

        if (data.Fone1.trim() === "") {
            setValue("FoneCelular1", data.FoneCelular);
        }
    }

    const maskBuilder = (telefone) => {
        if (!telefone || telefone.trim().length === 0 || telefone.trim().length < 8) return "(99) 99999-9999";

        let mascara = '';

        switch (telefone.trim().length) {
            case 8:
                mascara = "9999-9999";
                break;
            case 9:
                mascara = "99999-9999";
                break;
            case 10:
                mascara = "(99) 9999-9999";
                break
            case 11:
                mascara = "(99) 99999-9999";
                break;
            default:
                break;
        }

        return mascara;
    }

    const maskBuilderTelefone1 = (telefone) => {
        let mascara = maskBuilder(telefone);

        setMascaraTelefone1(mascara);
    }

    const maskBuilderTelefone2 = (telefone) => {
        let mascara = maskBuilder(telefone);

        setMascaraTelefone2(mascara);
    }

    const handleCheckNovaUC = (event) => {
        const checked = event.target.checked;

        setUnidadeConsumidora(checked);
        setValue('NovaUC', checked);

        if (checked) {
            setValue('CodigoUC', '');
        }
    };

    return (
        <div>
            <div className={styles['container-checkbox']}>
                <FormControlLabel
                    control=
                    {
                        <Checkbox
                            sx={{
                                color: '#B8B8B8 !important',
                                '&.Mui-checked': {
                                    color: '#6D79EC !important',
                                }
                            }}
                            checked={unidadeConsumidora}
                            onChange={(event) => { handleCheckNovaUC(event) }}
                            disabled={situacaoSolic !== 0 || desabilitarCamposSeHouverProtocoloGerado}
                        />
                    }
                    label={<span style={{ fontSize: '13px', color: '#b8b8b8' }}>Nova UC</span>}
                    labelPlacement="left"
                    className={styles['checkbox']}
                />
            </div>
            <div className={styles['input-container']}>
                <Controller
                    name="CodigoTipoGeracao"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']} style={{ zIndex: 3 }} >
                            <InputLabel htmlFor="consulta-CodigoTipoGeracao" shrink sx={{ color: "#b8b8b8" }}>Tipo fonte primária</InputLabel>
                            <TipoGeracaoSearchField
                                disabled={editavel}
                                field={field}
                                setErrorMessage={setErrorMessage}
                                setOpenError={setOpenError}
                                id="consulta-CodigoTipoGeracao"
                                onKeyDown={onKeyDown}
                                className={`${errors?.CodigoTipoGeracao ? styles.campoComValorErrado : ""}`}
                            />
                            {errors?.CodigoTipoGeracao && (
                                <HelperText text="Este campo é obrigatório" />
                            )}

                        </FormControl>
                    )}
                />

                <Controller
                    name="CodigoUC"
                    control={control}
                    render={({ field }) => {
                        const isNovaUC = uc.rn1095;

                        return (
                            <FormControl
                                id="unidade-consumidora"
                                variant="outlined"
                                className={styles['campos-m']}
                                style={{ zIndex: 2 }}
                                onBlur={recuperarDadosConsumidor}
                            >
                                <InputLabel shrink sx={{ color: "#b8b8b8" }}>
                                    {isNovaUC
                                        ? "Unidade Consumidora"
                                        : "Unidade consumidora* (sem dígito)"}
                                </InputLabel>

                                <WhiteInput
                                    fullWidth
                                    placeholder={isNovaUC ? "Unidade Consumidora" : "Código UC"}
                                    id="solicitacao-codigo-uc"
                                    type={isNovaUC ? "text" : "number"}
                                    readOnly={editavel || desabilitarCamposSeHouverProtocoloGerado}
                                    disabled={unidadeConsumidora}
                                    value={isNovaUC ? maskUC(field.value || "") : field.value || ""}
                                    onChange={(e) => {
                                        if (isNovaUC) {
                                            const raw = e.target.value.replace(/\D/g, "");
                                            field.onChange(raw);
                                        } else {
                                            field.onChange(e.target.value);
                                        }
                                    }}
                                    onKeyDown={onKeyDown}
                                    className={
                                        errors?.CodigoUC && !unidadeConsumidora
                                            ? styles.campoComValorErrado
                                            : ""
                                    }
                                />

                                {errors?.CodigoUC && !unidadeConsumidora && (
                                    <HelperText text={errors?.CodigoUC?.message} />
                                )}
                            </FormControl>
                        );
                    }}
                />
            </div>

            {erroAoRecuperarConsumidor && <p className={styles.erroAoRecuperarConsumidor}>Não foi encontrado um consumidor com a combinação de Inscrição e UC utilizadas</p>}

            <div className={`${styles['input-container']} ${erroAoRecuperarConsumidor ? styles['input-container-error'] : ""}`}>
                <Controller
                    name="TipoInscricao"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']} style={{ zIndex: 2 }}>
                            <InputLabel htmlFor="solicitacao-TipoInscricao" shrink sx={{ color: "#b8b8b8" }}>Tipo de inscrição</InputLabel>
                            <TipoInscricao
                                field={field}
                                setErrorMessage={setErrorMessage}
                                setOpenError={setOpenError}
                                id="consulta-TipoInscricao"
                                disabled={editavel}
                                onKeyDown={onKeyDown}
                                className={`${errors?.TipoInscricao ? styles.campoComValorErrado : ""}`}
                            />
                            {errors?.TipoInscricao && (
                                <HelperText text={errors?.TipoInscricao?.message} />
                            )}
                        </FormControl>
                    )}
                />

                <Controller
                    name="Inscricao"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                        <FormControl variant="outlined" className={styles['campos-m']} style={{ zIndex: 2 }} onBlur={recuperarDadosConsumidor}>
                            <InputLabel htmlFor="solicitacao-inscricao" shrink sx={{ color: "#b8b8b8" }}>Inscrição</InputLabel>
                            <InputMask
                                mask={getValues('TipoInscricao').value == 1 ? "999.999.999-99" : "**.***.***/****-99"}
                                onChange={onChange}
                                value={value}
                                readOnly={editavel || desabilitarCamposSeHouverProtocoloGerado}
                                id="solicitacao-inscricao"
                            >
                                {inputProps => (
                                    <WhiteInput
                                        readOnly={editavel || desabilitarCamposSeHouverProtocoloGerado}
                                        fullWidth
                                        placeholder="Inscrição"
                                        name="Inscrição"
                                        {...inputProps}
                                        onKeyDown={onKeyDown}
                                        className={`${errors?.Inscricao ? styles.campoComValorErrado : ""}`}
                                    />
                                )}
                            </InputMask>
                            {errors?.Inscricao ? (
                                <HelperText text={errors?.Inscricao?.message} />
                            ) : ''}
                        </FormControl>
                    )}
                />
            </div>

            <div className={styles['input-container']}>
                <Controller
                    name="Nome"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="solicitacao-nome" shrink sx={{ color: "#b8b8b8" }}>Interessado</InputLabel>
                            <WhiteInput
                                fullWidth
                                placeholder="Nome"
                                id="solicitacao-nome"
                                name="Nome"
                                {...field}
                                readOnly={editavel || !unidadeConsumidora}
                                onKeyDown={onKeyDown}
                                className={`${errors?.Nome ? styles.campoComValorErrado : ""}`}
                            />
                            {errors?.Nome && (
                                <HelperText text={errors?.Nome?.message} />
                            )}
                        </FormControl>
                    )}
                />

                <Controller
                    name="Email"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="solicitacao-email" shrink sx={{ color: "#b8b8b8" }}>E-mail interessado</InputLabel>
                            <WhiteInput
                                fullWidth
                                type="email"
                                placeholder="E-mail"
                                id="solicitacao-email"
                                name="Email"
                                {...field}
                                readOnly={editavel}
                                onKeyDown={onKeyDown}
                                className={`${errors?.Email ? styles.campoComValorErrado : ""}`}
                            />
                            {errors?.Email && (
                                <HelperText text={errors?.Email?.message} />
                            )}
                        </FormControl>
                    )}
                />
            </div>

            <div className={styles['input-container']}>
                <Controller
                    name="FoneCelular1"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="solicitacao-foneCelular1" shrink sx={{ color: "#b8b8b8" }}>Telefone 1</InputLabel>
                            <InputMask
                                mask={mascaraTelefone1}
                                onChange={onChange}
                                value={value}
                                readOnly={editavel}
                                id="solicitacao-foneCelular1"
                                onBlur={
                                    (event) => {
                                        let foneFormatado = formatarTelefone(event.target.value);

                                        maskBuilderTelefone1(foneFormatado);
                                    }
                                }
                                onFocus={
                                    (event) => {
                                        setMascaraTelefone1("(99) 99999-9999");
                                    }
                                }
                            >
                                {inputProps => (
                                    <WhiteInput
                                        fullWidth
                                        placeholder="Telefone"
                                        name="FoneCelular1"
                                        readOnly={editavel}
                                        {...inputProps}
                                        onKeyDown={onKeyDown}
                                        className={`${errors?.FoneCelular1 ? styles.campoComValorErrado : ""}`}
                                    />
                                )}
                            </InputMask>
                            {errors?.FoneCelular1 && (
                                <HelperText text={errors?.FoneCelular1?.message} />
                            )}
                        </FormControl>
                    )}
                />

                <Controller
                    name="FoneCelular2"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="solicitacao-foneCelular2" shrink sx={{ color: "#b8b8b8" }}>Telefone 2</InputLabel>
                            <InputMask
                                mask={mascaraTelefone2}
                                onChange={onChange}
                                value={value}
                                readOnly={editavel}
                                id="solicitacao-foneCelular2"
                                onBlur={
                                    (event) => {
                                        let foneFormatado = formatarTelefone(event.target.value);

                                        maskBuilderTelefone2(foneFormatado);
                                    }
                                }
                                onFocus={
                                    (event) => {
                                        setMascaraTelefone2("(99) 99999-9999");
                                    }
                                }
                            >
                                {inputProps => (
                                    <WhiteInput
                                        fullWidth
                                        placeholder="Telefone"
                                        name="FoneCelular2"
                                        readOnly={editavel}
                                        {...inputProps}
                                        onKeyDown={onKeyDown}
                                        className={`${errors?.FoneCelular2 ? styles.campoComValorErrado : ""}`}
                                    />
                                )}
                            </InputMask>
                            {errors?.FoneCelular2 && (
                                <HelperText text={errors?.FoneCelular2?.message} />
                            )}
                        </FormControl>
                    )}
                />
            </div>
        </div>
    )
}

export { Interessado };